import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { string } from 'prop-types';
import {
  params,
  shape,
  string as stringType,
  useDataModel,
  extend,
} from '@thd-nucleus/data-sources';
import styles from './article-info.module.scss';
import { ArticleInfoHero } from './ArticleInfoHero';
import { ArticleInfoDetails } from './ArticleInfoDetails';
import { ArticleInfoIntroduction } from './ArticleInfoIntroduction';

const ArticleInfo = ({ articleGUID }) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('article-info.ready');
  }, []);

  const { data } = useDataModel('article', {
    variables: { articleGUID },
  });

  const headerType = data?.article?.articleHeader?.type;
  const isVideo = headerType === 'video';

  const articleInfoClasses = classNames(
    styles['article-info'],
    isVideo ? styles['article-info__video-container'] : styles['article-info__image-container']
  );

  const articleInfoDetailsClasses = classNames(
    isVideo ? styles['article-info__video-details'] : styles['article-info__image-details']
  );

  const heroContainerClasses = classNames(
    isVideo
      ? styles['article-info__video-container__hero-container']
      : styles['article-info__image-container__hero-container']
  );
  return (
    <div className={articleInfoClasses} data-testid="article-info-component">
      <div className={heroContainerClasses}>
        <ArticleInfoHero articleGUID={articleGUID} />{' '}
      </div>
      <div className={articleInfoDetailsClasses}>
        <ArticleInfoDetails articleGUID={articleGUID} />
        <ArticleInfoIntroduction articleGUID={articleGUID} />
      </div>
    </div>
  );
};

ArticleInfo.propTypes = {
  articleGUID: string.isRequired,
};

ArticleInfo.displayName = 'ArticleInfo';

ArticleInfo.dataModel = extend(
  {
    article: params({ articleGUID: stringType().isRequired() }).shape({
      articleHeader: shape({
        type: stringType(),
      }),
    }),
  },
  ArticleInfoHero,
  ArticleInfoDetails,
  ArticleInfoIntroduction
);

export { ArticleInfo };
